/***
*
*   TOASTER
*   Toaster component
*
*   DOCS
*   https://docs.useMapMetrics Atlas.app/MapMetrics Atlas-web/components/toast
*   https://ui.shadcn.com/docs/components/toast
*
**********/

import { Toast, ToastClose, ToastDescription, ToastProvider, ToastTitle, ToastViewport } from './toast.jsx'
import { Icon } from 'components/lib';
import { useToast } from './useToast.js'

export function Toaster() {

  const { toasts } = useToast();
  const icons = {
    error: 'circle-x',
    success: 'circle-check-big',
    info: 'info',
    default: 'circle-check-big',
  }

  const getIconColor = (variant) => {
    switch(variant) {
      case 'error': return 'text-red-400';
      case 'success': return 'text-emerald-400';
      case 'info': return 'text-blue-400';
      default: return 'text-emerald-400';
    }
  }

  return (
    <ToastProvider>

      { toasts.map(({ id, title, description, action, ...props }) =>{
        const iconName = icons[props.variant] || icons.default;
        const iconColor = getIconColor(props.variant);
        
        return (

          <Toast key= {id } { ...props }>
            <div className='flex items-center'>

              <Icon 
                name={iconName} 
                size={ 20 } 
                className={`mr-4 flex-shrink-0 w-5 h-5 ${iconColor} drop-shadow-sm`}
              />
              
              <div>

                { title && 
                  <ToastTitle className="font-semibold text-white/95 poppins-semibold text-sm">{ title }</ToastTitle> 
                }

                { description && 
                  <ToastDescription className="text-white/80 poppins-light text-sm leading-relaxed mt-1">{ description }</ToastDescription> 
                }

              </div>
            </div>

            { action}
            <ToastClose />

          </Toast>
        )
      })}

      <ToastViewport/>

    </ToastProvider>
  );
}
